import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
// import OutsideClickHandler from 'react-outside-click-handler';

import { config } from 'app/config';
import { Dialog } from '../dialog/dialog';
import { Container, Image, LeftArrow, RightArrow } from './img-viewer.styled';

export const ImgViewer = (props) => {
  const { width, height, images, test } = props;
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const imgRef = useRef(null);

  /**
   * get active images
   * @returns
   */
  const getItems = () => {
    if (test) {
      return ['/images/photo-test1.jpg', '/images/photo-test2.jpg'];
    }
    const prefix = config.network.images_url;
    const out = [];
    images.forEach((el) => {
      if (el) {
        out.push(prefix + el);
      }
    });
    return out;
  };

  const items = getItems();

  /**
   * show image modal
   */
  // const clickOnImageHandler = () => {
  //   setShow((show) => !show);
  // };

  const onClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setShow((show) => !show);
  };

  /**
   * handle outside click
   */
  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (imgRef.current) {
  //       if (imgRef.current.contains(e.target)) {
  //         return;
  //       } else {
  //         clickOnImageHandler();
  //       }
  //     }
  //   };

  //   document.addEventListener('click', handleOutsideClick, false);
  //   return () => {
  //     document.removeEventListener('click', handleOutsideClick, false);
  //   };
  // }, []);

  /**
   * next image
   */
  const next = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const nextIndex = index + 1 > items.length - 1 ? 0 : index + 1;
    setIndex(nextIndex);
  };

  /**
   * prev image
   */
  const prev = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const nextIndex = index - 1 === -1 ? items.length - 1 : index - 1;
    setIndex(nextIndex);
  };

  const hide = () => {
    setShow(false);
  };

  /**
   * get current image
   * @returns
   */
  const getImage = () => {
    if (items && items[index]) {
      return <Image ref={imgRef} onClick={onClick} src={items[index]} alt="" />;
    }
    return <Image src="/images/no-photo.png" className="noimg" />;
  };

  const hideArrow = items.length <= 1;
  const image = getImage();

  return (
    <>
      <Container width={width} height={height}>
        {image}
        {!hideArrow && (
          <>
            <LeftArrow onClick={prev}>
              <i className="fa fa-angle-left" aria-hidden="true"></i>
            </LeftArrow>
            <RightArrow onClick={next}>
              <i className="fa fa-angle-right" aria-hidden="true"></i>
            </RightArrow>
          </>
        )}
      </Container>
      {show && (
        <Dialog className="img" noPortal close={hide} useCloseBtn closeOnOverlayClick closeOnEscape hideOverlay>
          {image}
        </Dialog>
      )}
    </>
  );
};

ImgViewer.propTypes = {
  images: PropTypes.any.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
};
